// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const IconMenuContainer = styled.ul`
    display: flex;
    justify-content: space-around;
    list-style-type: none;
    padding: 0;
    width: 100%;
`;

export const Item = styled.li`
    text-align: center;
    line-height: 3em;
    color: ${p =>
        new Map([
            [true, p.theme.primaryFontColor],
            [p.disabled && !p.isSelected, p.theme.mediumGrey],
            [p.isSelected, p.theme.mainBrandColor]
        ]).get(true)};
    transition: color 0.4s ease-in-out;

    &:hover {
        cursor: pointer;
        color: ${props => !props.disabled && props.theme.mainBrandColor};
    }
`;

const iconSizeNormal = '1.5em';

export const Icon = styled(SVGIcon)`
    height: ${iconSizeNormal};
    position: relative;
    top: calc(${iconSizeNormal} / 4);
    width: ${iconSizeNormal};

    & g {
        fill: ${p =>
            new Map([
                [true, p.theme.primaryFontColor],
                [p.disabled && !p.isSelected, p.theme.mediumGrey],
                [p.isSelected, p.theme.mainBrandColor]
            ]).get(true)};
        transition: fill 0.1s ease-in-out;
    }

    ${Item}:hover & {
        & g {
            fill: ${props => !props.disabled && props.theme.mainBrandColor};
        }
    }
`;

export const Icons = styled.div`
    display: inline-block;
    margin-right: 0.3em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/icon-menu/styles.js